var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.349,
    height: 12.698,
    viewBox: "0 0 7.349 12.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-arrow-right",
    "data-name": "Icon feather-arrow-right",
    transform: "translate(-8.218 -6.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M18,7.5l4.935,4.935L18,17.369",
    transform: "translate(-8.368 0)",
    fill: "none",
    stroke: "#373737",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownArrow);
export default __webpack_public_path__ + "static/media/up_down_arrow.0211e5cb64c8f515ed80659a65298f57.svg";
export { ForwardRef as ReactComponent };